<template>
  <div class="max-navigation-shell">
    <div class="view-header-nav-shell" v-show="nav_show">
      <div class="view-header-content">
        <div class="nav-shell">
          <div
            class="header-box"
            @click="$router.push('/')"
            :class="{ ' header-box-active': nav_code == 'Home' }"
          >
            首页
          </div>
          <div
            class="header-box"
            @click="$router.push('/classify')"
            :class="{ ' header-box-active': nav_code == 'classify' }"
          >
            课程分类
            <img src="@/assets/pull-down.png" alt="" class="pull-icon" />
            <div class="class-piker-shell">
              <div class="lv1-list">
                <div
                  class="lv1-box"
                  v-for="(item, index) in nav_list"
                  :key="index"
                  @click.stop="$router.push('/classify?lv1_id=' + item.cate_id)"
                >
                  {{ item.cate_name }}
                  <div class="lv2-list">
                    <div
                      @click.stop="
                        $router.push(
                          '/classify?lv1_id=' +
                            item.cate_id +
                            '&lv2_id=' +
                            item2.cate_id
                        )
                      "
                      class="lv2-box"
                      v-for="(item2, index2) in item.child_nav"
                      :key="index2 + 'lv2'"
                    >
                      {{ item2.cate_name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="header-box"
            @click="$router.push('/journalism')"
            :class="{ ' header-box-active': nav_code == 'journalism' }"
          >
            行业资讯
          </div>
          <div
            class="header-box"
            @click="$router.push('/AboutUs')"
            :class="{ ' header-box-active': nav_code == 'AboutUs' }"
          >
            关于我们
          </div>
          <div
            class="header-box"
            @click="downloadApp"
          >
            手机APP学习
          </div>
        </div>
        <div class="user-info-login">
          <div class="login-reg-shell" v-if="!is_login">
            <div class="login-btn" @click="on_login()">登录</div>
            <!-- |
            <div class="login-btn" @click="on_reg()">注册</div> -->
          </div>
          <div class="user-img" v-if="is_login">
            <!-- <div
              class="cut-handle-btn"
              @click.stop="cut_identity_show = true"
              v-if="phar_status !== 0"
            >
              <img src="@/assets/login/login_cut.png" class="cut-icon" alt="" />
              切换
            </div> -->
            <el-dropdown size="medium ">
              <img
                :src="user_head_img_url ? user_head_img_url : head_img_url"
                alt=""
              />
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="$router.push('/personal')"
                  >我的课程</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native="$router.push('/personal?code=2')"
                  >我的试题
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="$router.push('/personal?code=6')"
                  >个人信息
                </el-dropdown-item>
                <el-dropdown-item @click.native="logout"
                  >退出登录</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <!--        执业药师继续教育课程选择bar-->
    <div class="header-title" v-show="!nav_show">执业药师继续教育课程选择</div>
    <!-- 登入弹出框 -->
    <el-dialog
      class="dialog"
      custom-class="login-reg"
      title="欢迎您来到湘源医药食品教育平台"
      :visible.sync="dialogVisible"
      width="500px">
      <div class="login-tab">
        <div
          class="tab-box"
          :class="{ 'tab-box-active': item.code == tab_code }"
          @click.stop="cut_tab(item, index)"
          v-for="(item, index) in tab_list"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="login-content" v-show="tab_code == 1">
        <van-form class="form" @submit="onSubmit">
          <van-field
            v-model.number="form.phone"
            maxlength="11"
            placeholder="请输入正确的手机号码"
            :rules="[
              { required: true },
              {
                pattern: /^1[3|5|6|7|8|9]\d{9}$/,
                message: '请输入正确的手机号码',
              },
            ]"
          >
            <i slot="left-icon">
              <img class="zhanghao" src="@/assets/zhanghao.png" alt />
            </i>
          </van-field>
          <van-field
            placeholder="请输入密码"
            type="password"
            v-model="form.passwrod"
            maxlength="16"
            :rules="[
              { required: true },
              {
                min: 6,
                max: 16,
                message: '请输入6到16位的密码',
              },
            ]"
          >
            <i slot="left-icon">
              <img class="mima" src="@/assets/mima.png" alt />
            </i>
          </van-field>
          <div style="margin: 16px;">
            <van-button color="#2AA9B5" round block native-type="submit"
              >登录
            </van-button>
          </div>
        </van-form>
      </div>
      <div class="login-content" v-show="tab_code == 2">
        <van-form class="form" @submit="senior_login">
          <van-field
            v-model="numberId"
            maxlength="19"
            placeholder="请输入身份证号码"
            :rules="[
              { required: true },
              {
                pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                message: '请输入正确的身份证号码',
              },
            ]"
          >
            <i slot="left-icon">
              <img class="zhanghao" src="@/assets/zhanghao.png" alt />
            </i>
          </van-field>
          <van-field
            placeholder="请输入密码, 默认身份证后六位"
            type="password"
            v-model="senior_password"
            maxlength="16"
            :rules="[
              { required: true },
              {
                min: 6,
                max: 16,
                message: '请输入6到16位的密码',
              },
            ]"
          >
            <i slot="left-icon">
              <img class="mima" src="@/assets/mima.png" alt />
            </i>
          </van-field>
          <div class="block">
            <div class="demonstration">
              选择年份:
            </div>
            <van-checkbox v-model="value3">2020年</van-checkbox>
            <van-checkbox v-model="checked">补学</van-checkbox>
          </div>
          <div style="margin: 16px;">
            <van-button color="#2AA9B5" round block native-type="submit"
              >登录
            </van-button>
          </div>
        </van-form>
        <div class="login-tips" v-if="login_error">
          <p>1、您的身份证号、密码或类型是否错误？</p>
          <p>
            2、您是否没有报名？报名请进“湖南省药师教育管理平台
            <a href="https://yaoshi.hnmpaed.com">https://yaoshi.hnmpaed.com</a>
            →药师注册/登录→教育培训→远程→中国药科大学湖南函授站
          </p>
        </div>
      </div>
      <div class="bottom-handle">
        <!-- <div class="handle-btn" @click="go_reg">还没有账号，立即注册</div>
        <div class="handle-btn" @click="forget_password">忘记密码 找回密码</div> -->
      </div>
    </el-dialog>
    <!-- 注册弹出框 -->
    <el-dialog
      title="欢迎您来到湘源教育学习平台"
      class="dialog"
      :visible.sync="register"
      width="500px"
      custom-class="login-reg">
      <div class="login-tab">
        <div
          class="tab-box"
          :class="{ 'tab-box-active': item.code == tab_code2 }"
          @click.stop="cut_tab2(item, index)"
          v-for="(item, index) in tab_list2"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="login-content" v-if="tab_code2 == 1">
        <van-form @submit="registers">
          <van-field
            v-model.number="phone"
            maxlength="11"
            placeholder="请输入手机号码"
            :rules="[
              { required: true },
              {
                pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
                message: '请输入正确的手机号码',
              },
            ]"
          >
            <i slot="left-icon">
              <img class="zhanghao" src="@/assets/zhanghao.png" alt />
            </i>
          </van-field>
          <van-field
            v-model.number="verification"
            maxlength="6"
            center
            clearable
            placeholder="请输入验证码"
          >
            <i slot="left-icon">
              <img class="yanzhengma" src="@/assets/yanzhengma.png" alt />
            </i>
            <template #button>
              <van-count-down
                v-if="timeDown"
                :time="60000"
                format="重新发送ss s"
                @change="countDown($event)"
              />
              <button
                v-else
                class="Btn111"
                type="primary"
                @click.stop="sendVcode()"
              >
                发送验证码
              </button>
            </template>
          </van-field>
          <van-field
            v-model="numberId"
            maxlength="18"
            placeholder="请输入身份证号码"
            :rules="[{ required: true }]"
          >
            <i slot="left-icon">
              <img
                class="shimingyanzheng"
                src="@/assets/shimingyanzheng.png"
                alt
              />
            </i>
          </van-field>
          <van-field
            v-model="password"
            clearable
            placeholder="请设置密码"
            type="password"
            maxlength="16"
            :rules="[
              [
                { required: true, message: '请输入密码' },
                {
                  min: 6,
                  max: 16,
                  message: '请输入6到16位的密码',
                },
              ],
            ]"
          >
            <i slot="left-icon">
              <img class="mima" src="@/assets/mima.png" alt />
            </i>
          </van-field>
          <!-- 提交按钮 -->
          <div style="margin: 16px;">
            <van-button color="#2AA9B5" round block native-type="submit"
              >注册并登录
            </van-button>
          </div>
        </van-form>
      </div>
      <div class="login-content" v-if="tab_code2 == 2">
        <van-form @submit="forget">
          <van-field
            v-model.number="for_phone"
            maxlength="11"
            placeholder="请输入手机号码"
            :rules="[
              { required: true },
              {
                pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
                message: '请输入正确的手机号码',
              },
            ]"
          >
            <i slot="left-icon">
              <img class="zhanghao" src="@/assets/zhanghao.png" alt />
            </i>
          </van-field>
          <van-field
            v-model.number="for_code"
            maxlength="6"
            center
            clearable
            placeholder="请输入验证码"
          >
            <i slot="left-icon">
              <img class="yanzhengma" src="@/assets/yanzhengma.png" alt />
            </i>
            <template #button>
              <van-count-down
                v-if="timeDown"
                :time="60000"
                format="重新发送ss s"
                @change="countDown($event)"
              />
              <button
                v-else
                class="Btn111"
                type="primary"
                @click.stop="sendVcode('for_code')"
              >
                获取验证码
              </button>
            </template>
          </van-field>
          <van-field
            v-model="for_password"
            clearable
            placeholder="请设置密码，密码长度6-18位"
            type="password"
            maxlength="16"
            :rules="[
              { required: true, message: '请设置密码，密码长度6-18位' },
              {
                pattern: /[A-Za-z0-9]{6,18}$/,
                message: '请设置密码，密码长度6-18位，包含数字和字母',
              },
            ]"
          >
            <i slot="left-icon">
              <img class="mima" src="@/assets/mima.png" alt />
            </i>
          </van-field>
          <!-- 提交按钮 -->
          <div style="margin: 16px;">
            <van-button color="#2AA9B5" round block native-type="submit"
              >确定修改
            </van-button>
          </div>
        </van-form>
      </div>
      <div class="bottom-handle">
        <div
          class="handle-btn"
          @click.stop="
            register = false;
            login_popup_show = true;
          "
        >
          已有账号,去登录
        </div>
      </div>
    </el-dialog>
    <div class="login-popup-shell" v-show="login_popup_show">
      <div class="login-popup-content" @click.stop="">
        <div class="login-popup-content-header">
          <div class="login-popup-logo">
            <img src="@/assets/login/login_logo.png" alt="" />
            <img
              src="@/assets/login/login_close.png"
              alt=""
              class="close-login-popup"
              @click.stop="login_popup_show = false"
            />
          </div>
        </div>
        <div class="login-popup-content-footer">
          <div class="login-from-shell">
            <div class="login-from-title"></div>
            <div class="login-from-box">
              <input
                type="text"
                placeholder="请输入手机号"
                maxlength="18"
                v-model="card_num"
                autofocus="autofocus"
                autocomplete="off"
              />
            </div>
            <div class="login-from-box">
              <input
                type="password"
                placeholder="请输入密码,默认手机号后六位"
                maxlength="16"
                v-model="user_pwd"
                autocomplete="off"
              />
            </div>
            <div class="login-from-bottom-handlle">
              <div class="bottom-handle-btn" @click.stop="forget_password">
                修改密码
              </div>
            </div>
            <div class="privacy">
              <p v-if="privacy_checked" class="checked" @click="privacy_checked = !privacy_checked"><i class="el-icon-check"></i></p>
              <p v-else  @click="privacy_checked = !privacy_checked"></p>
              <div>我已阅读并同意<span @click="handlePrivacy(7)">《用户协议》</span>和<span @click="handlePrivacy(9)">《隐私政策》</span>。</div>
            </div>
            <div class="login-from-btn" @click.stop="new_login">登录</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="login-popup-shell cut-identity-shell"
      v-show="cut_identity_show"
    >
      <div class="cut-identity-content" @click.stop="">
        <div class="cut-title">请选择身份</div>
        <img
          src="@/assets/colse-icon.png"
          alt=""
          class="close-popup-cut"
          @click.stop="cut_identity_show = false"
        />
        <div class="cut-list">
          <div
            class="cut-box"
            :class="{ 'cut-box-active': is_buxue == 2 }"
            @click="cut_id(phar_id1, '2')"
          >
            <img
              src="@/assets/login/login_icon1.png"
              alt=""
              class="cut-icon"
              v-if="is_buxue == 1"
            />
            <img
              src="@/assets/login/login_icon2.png"
              alt=""
              class="cut-icon"
              v-else
            />
            <div class="cut-name">新学</div>
          </div>
          <div
            class="cut-box"
            :class="{ 'cut-box-active': is_buxue == 1 }"
            @click="cut_id(phar_id2, '1')"
          >
            <img
              src="@/assets/login/login_icon4.png"
              alt=""
              class="cut-icon"
              v-if="is_buxue == 1"
            />
            <img
              src="@/assets/login/login_icon3.png"
              alt=""
              class="cut-icon"
              v-else
            />
            <div class="cut-name">补学</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 提示 -->
    <div
      class="video-photo-shell"
      v-show="applet_show"
      @click.stop="applet_show = false"
    >
      <div class="camera_outer">
        <div class="title">
          扫码“湘源教育”APP下载
        </div>
        <img src="@/assets/APPLoad.jpg" alt="" class="applet-img" />
      </div>
    </div>
  </div>
</template>

<script>
import { testIdCard, testPhone } from "@/utils/index.js";

export default {
  props: {
    fatherMethod: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      cut_identity_show: false,
      login_popup_show: false,
      senior_password: "",
      checked: false,
      privacy_checked: false,
      value3: "",
      numberId: "",
      tab_code: 1,
      tab_list: [
        {
          name: "普通用户",
          code: 1,
        },
        {
          name: "继续教育",
          code: 2,
        },
      ],
      tab_code2: 1,
      tab_list2: [
        // {
        //   name: "注册",
        //   code: 1,
        // },
        {
          name: "修改密码",
          code: 2,
        },
      ],
      nav_code: "Home",
      is_login: false,
      show: false,
      head_img_url: require("../../../assets/head.png"),
      user_head_img_url: "",
      nav_list: [],
      nav_show: true,
      user_info: "",
      // 登录 注册
      // 登入弹出框显示隐藏
      dialogVisible: false,
      // 登入的表单
      form: {
        // 手机号码 17607696783
        phone: "",
        // 密码 qwer4321
        passwrod: "",
      },
      // 注册弹出框显示隐藏
      register: false,
      // 接收的验证码
      veri_code: "",
      // 输入的验证码
      verification: "",
      // 注册手机号
      phone: "",
      //   注册身份证号码
      numberId: "",
      //   注册密码
      password: "",
      //   注册计时器
      timeDown: false,
      login_error: false,
      // 忘记密码
      for_phone: "",
      for_code: "",
      for_password: "",
      card_num: "430821199409164518",
      user_pwd: "164518",
      card_num: "",
      user_pwd: "",
      phar_status: 0,
      phar_info: [],
      phar_id1: "",
      phar_id2: "",
      is_buxue: null,
      applet_show: false
    };
  },
  mounted() {
    this.is_buxue = localStorage.getItem("is_buxue");
    this.user_head_img_url = this.$store.state.user_img;
    if (this.$route.query.invite_code) {
      localStorage.setItem("invite_code", this.$route.query.invite_code);
    }
    // if (this.$route.name === "pharmacist-course") {
    //   this.nav_show = false;
    // } else {
    //   this.nav_show = true;
    // }
    this.get_class_list();
    if (localStorage.getItem("token")) {
      this.getUserInfo();
      if (localStorage.getItem("phar_status")) {
        this.phar_status = localStorage.getItem("phar_status");
        if (this.phar_status > 0) {
          this.phar_id1 = localStorage.getItem("phar_id1");
          if (localStorage.getItem("phar_id2")) {
            this.phar_id2 = localStorage.getItem("phar_id2");
          }
          if (this.phar_status == 1) {
            // this.API.post2('login/user_acc-phar_choose', {
            //   phar_id: this.phar_id1 ? this.phar_id1 : this.phar_id2
            // }).then((res) => {
            //   if (res.errno == 0) {
            //     this.login_popup_show = false
            //     localStorage.setItem('token', res.data.token)
            //     this.cut_identity_show = false
            //     this.getUserInfo()
            //     if (res.data.course_status) {
            //       this.$router.push('/personal')
            //     } else {
            //       this.$router.push('/pharmacist-course')
            //     }
            //   } else {
            //     this.API.SMessage(res.message)
            //   }
            // })
          }
        }
      }
    }
  },
  methods: {
    cut_id(val, type) {
      this.is_buxue = type;
      localStorage.setItem("is_buxue", type);
      this.API.post2("login/user_acc-phar_choose", {
        phar_id: val,
      }).then((res) => {
        if (res.errno == 0) {
          this.login_popup_show = false;
          localStorage.setItem("token", res.data.token);
          this.cut_identity_show = false;
          this.getUserInfo();
          if (res.data.course_status) {
            this.$router.push("/personal");
            localStorage.setItem("buy_phar", "1");
          } else {
            localStorage.setItem("buy_phar", "2");
            this.$router.push("/pharmacist-course");
          }
        } else {
          this.API.SMessage(res.message);
        }
      });
    },
    new_login() {
      if (!this.privacy_checked) {
        this.$message.warning('请先阅读用户协议和隐私政策!')
        return;
      }
      if (!this.card_num) {
        return this.API.SMessage("请输入手机号");
      }
      if (this.card_num.length < 14 && !testPhone(this.card_num)) {
        return this.API.SMessage("请输入正确的手机号");
      }
      // if (this.card_num.length > 14 && !testIdCard(this.card_num)) {
      //   return this.API.SMessage("请输入正确的手机号/身份证号码");
      // }
      if (!this.card_num) {
        return this.API.SMessage("请输入密码");
      }
      this.API.post("login/user_acc-card_login", {
        card_num: this.card_num,
        user_pwd: this.user_pwd,
      }).then((res) => {
        if (res.errno == 0) {
          this.phar_status = res.data.phar_status;
          this.phar_info = res.data.phar_info;
          this.$Bus.$emit('loginOk')
          if (res.data.is_buxue) {
            localStorage.setItem("is_buxue", "1");
          } else {
            localStorage.setItem("is_buxue", "2");
          }
          this.is_buxue = localStorage.getItem("is_buxue");
          this.API.SMessage("登录成功");
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("phar_status", this.phar_status);
          if (this.phar_status > 0) {
            if (this.phar_info[0].is_buxue == 0) {
              localStorage.setItem("phar_id1", this.phar_info[0].info_id);
            } else {
              localStorage.setItem("phar_id2", this.phar_info[0].info_id);
            }
            if (this.phar_info.length == 2) {
              if (this.phar_info[1].is_buxue == 1) {
                localStorage.setItem("phar_id2", this.phar_info[1].info_id);
              } else {
                localStorage.setItem("phar_id1", this.phar_info[1].info_id);
              }
            }
            this.phar_id1 = localStorage.getItem("phar_id1");
            this.phar_id2 = localStorage.getItem("phar_id2");
            if (this.phar_info.length > 0) {
              this.cut_id(this.phar_info[0].info_id);
            } else {
              this.$router.go(0);
            }
          } else {
            this.$router.go(0);
          }
          this.show = true;
          this.login_popup_show = false;
        } else {
          this.API.SMessage(res.message);
        }
      });
    },
    go_reg(code) {
      this.tab_code2 = 1;
      this.login_popup_show = false;
      this.register = true;
    },
    forget_password() {
      this.tab_code2 = 2;
      this.login_popup_show = false;
      this.register = true;
    },
    cut_tab(item, index) {
      this.tab_code = item.code;
      this.numberId = "";
    },
    cut_tab2(item, index) {
      this.tab_code2 = item.code;
    },
    on_login() {
      this.login_popup_show = true;
      this.numberId = "";
    },
    on_reg() {
      this.numberId = "";
      this.register = true;
    },
    get_class_list() {
      this.API.post("Home/course_out-get_course_nav", {}).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        this.nav_list = res.data.nav_list;
      });
    },
    handleSelect(e) {},
    // 退出登录
    logout() {
      this.API.post("login/user_acc-login_out", {}).then((res) => {
        this.API.SMessage("登出成功");
        this.is_login = false;
        this.user_info = "";
        localStorage.clear();
        window.location.href = location.protocol + "//" + location.host;
      });
    },
    // 获取用户信息
    getUserInfo() {
      this.API.post("user/user_infos-user_info", {}).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        if (res.code == 10010) {
          this.user_info = res.data.user_info;
          this.$store.state.user_info = this.user_info;
          this.$store.state.user_img = this.user_info.head_img_url;
          this.user_head_img_url = this.user_info.head_img_url;
          this.is_login = true;
          localStorage.setItem("user_id", this.user_info.user_id);
          localStorage.setItem("user_info", JSON.stringify(this.user_info));
        } else {
          this.is_login = false;
        }
      });
    },
    // 验证码倒计时
    countDown({ days, hours, minutes, seconds }) {
      if (!days && !hours && !minutes && !seconds) {
        this.timeDown = false;
      }
    },
    // 获取验证码
    async sendVcode(type) {
      try {
        this.API.post("login/user_acc-get_msg_code", {
          user_acc: type == "for_code" ? this.for_phone : this.phone,
        }).then((data) => {
          if (data.errno == 0) {
            // this.veri_code = data.data.sms_code
          } else {
            this.API.SMessage(data.message);
          }
        });
      } catch (err) {
        console.log(err);
      }
      this.timeDown = true;
    },
    // 登入
    async onSubmit() {
      try {
        this.API.post2("login/user_acc-login_pass", {
          user_acc: this.form.phone,
          user_pwd: this.form.passwrod,
        }).then((data) => {
          if (data.errno == 0) {
            this.API.SMessage("登入成功");
            localStorage.setItem("token", data.data.token);
            this.getUserInfo();
            this.$store.commit("getToken", data.data.token);
            this.login_popup_show = false;
            this.show = true;
            this.form.phone = "";
            this.form.passwrod = "";
            this.$router.go(0);
          } else {
            this.API.SMessage(data.message);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    senior_login() {
      if (!this.checked && !this.value3) {
        return this.API.SMessage("请选择年份/补学");
      }
      if (!this.numberId) {
        return this.API.SMessage("请输入手机号");
      }
      if (!this.senior_password) {
        return this.API.SMessage("请输入密码");
      }
      this.API.post2("login/user_acc-phar_login", {
        id_card: this.numberId,
        user_pwd: this.senior_password,
        in_year: this.value3 ? 2020 : 0,
        is_buxue: this.checked ? 1 : 0,
      }).then((res) => {
        if (res.errno == 0) {
          this.login_popup_show = false;
          this.API.SMessage("登录成功");
          localStorage.setItem("token", res.data.token);
          this.getUserInfo();
          if (res.code === 10010) {
            if (res.data.course_status) {
              this.$router.push("/personal");
            } else {
              this.$router.push("/pharmacist-course");
            }
          } else {
            this.API.SMessage(data.message);
          }
        } else {
          this.API.SMessage(res.message);
          this.login_error = true;
        }
      });
    },
    // 注册
    async registers() {
      try {
        this.API.post("login/user_acc-register_user", {
          user_acc: this.phone,
          veri_code: this.verification,
          password: this.password,
          id_card: this.numberId,
          invite_code: localStorage.getItem("invite_code"),
        }).then((data) => {
          if (data.errno == 0) {
            this.$message({
              showClose: true,
              message: "注册成功",
              type: "success",
            });
            localStorage.setItem("token", data.data.token);
            this.getUserInfo();
            this.show = true;
            this.register = false;
            this.phone = "";
            this.verification = "";
            this.password = "";
            this.numberId = "";
            this.$router.go(0);
          } else {
            this.$message({
              showClose: true,
              message: data.message,
              type: "warning",
            });
          }
        });
      } catch (err) {}
    },
    async forget() {
      if (!this.for_phone) {
        return this.API.SMessage("请输入手机号");
      }
      if (!this.for_code) {
        return this.API.SMessage("请输入验证码");
      }
      if (!this.for_password) {
        return this.API.SMessage("请输入密码");
      }
      this.API.post("login/user_acc-forget_pwd", {
        user_acc: this.for_phone,
        user_pwd: this.for_password,
        veri_code: this.for_code,
      }).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        this.for_phone = "";
        this.for_password = "";
        this.for_code = "";
        this.API.SMessage(res.message);
        setTimeout(() => {
          this.login_popup_show = true;
          this.register = false;
        }, 2000);
      });
    },
    downloadApp () {
      this.applet_show = true
    },
    handlePrivacy (type) {
      this.$router.push({path: '/privacy?type=' + type})
    }
  },
  watch: {
    $route: function() {
      // console.log(this.$route.name)
      this.nav_code = this.$route.name;
    },
    checked: function() {
      if (this.checked) {
        this.value3 = false;
      } else {
      }
    },
    value3: function() {
      if (this.value3) {
        this.checked = false;
      } else {
      }
    },
  },
};
</script>

<style lang="less" scoped>
.popup-login {
  min-height: 500px !important;
}

.demonstration {
  margin: 10px 0;
}

.login-tab {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  .tab-box {
    text-align: center;
    width: 40%;
    padding: 5px 10px;
    cursor: pointer;
    font-size: 20px;
  }

  .tab-box-active {
    border-bottom: 4px solid #2aa9b5;
  }
}

.login-content {
  padding: 30px 0;

  .login-tips {
    color: red;
    margin-top: 40px;
    line-height: 20px;

    a {
      color: red;
    }

    p {
      line-height: 30px;
      font-size: 16px;
    }
  }

  /deep/ .from {
    min-height: 4rem;
  }
}

.bottom-handle {
  display: flex;
  align-items: center;
  height: 60px;

  .handle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48%;
    font-size: 16px;
    color: #2aa9b5;
    cursor: pointer;  
  }
}

.view-header-nav-shell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  background-color: #2aa9b5;

  .view-header-content {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 1200px;
    height: 100%;

    .nav-shell {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 70%;
      height: 100%;
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;

      .header-box {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        flex: 1;
        position: relative;
        cursor: pointer;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;

        &:hover {
          .class-piker-shell {
            display: block !important;
          }
        }

        .pull-icon {
          width: 18px;
          height: 10px;
          margin-left: 3px;
        }
      }

      .header-box-active {
        background-color: #18949c;
      }
    }

    .user-info-login {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 30%;
      height: 100%;

      .cut-handle-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 36px;
        background: #2aa9b5;
        border: 1px solid #eceded;
        border-radius: 23px;
        margin-right: 15px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;

        .cut-icon {
          width: 24px;
          height: 24px;
          margin-right: 2px;
        }
      }

      .login-reg-shell {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #f1eded;
      }

      .user-img {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        height: 100%;

        span {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #f1eded;
        }

        img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }
      }
    }
  }
}

.class-piker-shell {
  display: none;
  position: absolute;
  top: 80px;
  left: 0px;
  background-color: #fff;
  z-index: 99;

  .lv1-list {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    background-color: #ffffff;
    position: relative;
    box-shadow: 0px 4px 8px 0px rgba(153, 153, 153, 0.18);

    .lv1-box {
      position: relative;
      display: flex;
      align-items: center;
      height: 50px;
      min-width: 212px;
      background-color: #f1f1f1;
      padding: 0 20px;
      cursor: pointer;

      .lv2-list {
        display: none;
      }

      &:hover {
        color: #2aa9b5;
        background-color: #fff;

        .lv2-list {
          display: block;
          position: absolute;
          top: 1px;
          left: 100%;
          min-width: 230px;
          min-height: 100%;
          background-color: #fff;
          z-index: 99;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;

          .lv2-box {
            display: flex;
            align-items: center;
            padding: 0 20px;
            height: 50px;
            width: 100%;
            cursor: pointer;

            &:hover {
              color: #2aa9c6;
            }
          }
        }
      }
    }
  }
}

.header-title {
  display: flex;
  align-items: center;
  padding: 0 6%;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  height: 100px;
  background: #2aa9b5;
}

.login-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
}

.login-btn {
  display: flex;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #f1eded;
  padding: 0 20px;
  cursor: pointer;
}

.box {
  width: 100%;
  height: 100%;

  .navigation {
    height: 100px;
    background: #2aa9b5;

    ul {
      width: 1200px;
      height: 100px;
      margin: auto;

      li {
        float: left;
        width: 210px;
        height: 100%;
        line-height: 100px;
        text-align: center;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;

        img {
          margin-left: 10px;
          margin-bottom: 5px;
        }
      }

      li:hover {
        background: #078084;
        width: 210px;
        height: 99px;
        background: #078084;
        opacity: 0.5;
      }

      .login {
        float: right;
        line-height: 100px;
        text-align: center;

        span {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #f1eded;
        }

        img {
          position: relative;
          right: 0;
          top: 25px;
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }
      }
    }
  }

  .w {
    min-width: 1200px;
    margin: 0 auto;

    .zhong {
      width: 100%;
      overflow: hidden;

      .yun {
        float: left;
        margin: 0;
        width: 942px;
        height: 500px;
        margin-top: 38px;
        margin-right: 18px;
        /*background: url("~@/assets/1002061.jpg") no-repeat;*/
        background-size: 100% 100%;
        border-radius: 10px;
        padding: 0;

        .swiper-box {
          width: 94%;
          height: 100%;
          margin-top: 10px;
          overflow: hidden;
          position: relative;

          img {
            display: inline-block;
            border-radius: 18px;
            width: 100%;
            height: 100%;
          }
        }
      }

      .login {
        margin-top: 38px;
        float: left;
        width: 240px;
        height: 500px;
        background-color: #3a4459;
        border-radius: 10px;

        .img {
          width: 100px;
          height: 100px;
          margin: 65px 70px 22px 70px;
          border-radius: 50%;
        }

        .go {
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
        }

        .go1 {
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
          margin-bottom: 40px;
        }

        .Btn {
          width: 160px;
          height: 50px;
          background: #ffffff;
          border-radius: 25px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #3a4459;
          border: 0;
          margin: 64px 33px 26px 47px;
          outline: none;
        }

        .Btns {
          width: 160px;
          height: 50px;
          border: 1px solid #ffffff;
          border-radius: 25px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          background-color: #3a4459;
          margin: 0 33px 26px 47px;
          outline: none;
        }

        .help {
          margin-bottom: 20px;

          span {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            margin-left: 31px;
          }

          .img1 {
            width: 36px;
            height: 28px;
            margin-left: 50px;
          }

          .img2 {
            width: 29px;
            height: 30px;
            margin-left: 75px;
          }

          .img3 {
            width: 35px;
            height: 34px;
            margin-left: 51px;
          }

          .img4 {
            width: 29px;
            height: 30px;
            margin-left: 75px;
          }
        }
      }
    }

    .inform {
      width: 1200px;
      height: 90px;
      background: #ffffff;
      border: 1px dashed #d2d2d2;
      margin-top: 42px;

      .news-sehll {
        height: 100%;
        overflow: hidden;
        position: relative;

        .swiper-box {
          height: 100%;
        }
      }

      img {
        float: left;
        margin: 20px 20px 20px 29px;
        width: 80px;
        height: 50px;
      }

      span {
        line-height: 90px;
      }

      .span2 {
        float: right;
        margin-right: 31px;
      }
    }

    .continue {
      width: 1200px;
      height: 230px;
      margin-top: 37px;
    }
  }
}

/deep/ .el-dialog__body {
  padding-bottom: 0px;
  min-height: 360px;
}

i {
  .zhanghao {
    width: 24px;
    height: 32px;
    margin-right: 18px;
  }

  .mima {
    width: 26px;
    height: 30px;
    margin-right: 18px;
  }

  .shimingyanzheng {
    width: 33px;
    height: 26px;
    margin-right: 10px;
  }

  .yanzhengma {
    width: 30px;
    height: 30px;
    margin-right: 17px;
  }
}

.form {
  height: 230px;
}

.yanzhengma {
  width: 26px;
  height: 30px;
  margin-right: 17px;
}

.Btn111 {
  width: 100px;
  height: 30px;
  border: 0;
  border-radius: 10px;
}

.block {
}

.van-checkbox {
  display: inline-block;
  position: relative;
  top: 8px;
}

/deep/ .van-checkbox__icon {
  margin-left: 36px;
  display: inline-block;
}

/deep/ .van-checkbox__icon--checked .van-icon-success {
  background-color: #2aa9b5;
}

.login-reg {
  min-width: 500px;
}

.login-popup-shell {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;

  .login-popup-content {
    border: 1px solid transparent;

    .login-popup-content-header {
      width: 600px;
      height: 272px;
      background: #2aa9b5;
      border: 1px solid transparent;
      border-radius: 10px 10px 0px 0px;

      .login-popup-logo {
        display: block;
        width: 420px;
        height: 67px;
        margin: 70px auto 39px;
        position: relative;

        img {
          width: 100%;
        }

        .close-login-popup {
          width: 24px;
          height: 24px;
          position: absolute;
          top: -40px;
          right: -40px;
          cursor: pointer;
        }
      }
    }

    .login-popup-content-footer {
      width: 600px;
      height: 420px;
      background: #f8f8f8;
      border-radius: 0px 0px 10px 10px;
      border: 1px solid transparent;

      .login-from-shell {
        width: 560px;
        height: 495px;
        background: #ffffff;
        box-shadow: 0px -2px 35px 0px rgba(102, 102, 102, 0.12);
        border-radius: 10px;
        margin: -96px auto;

        .login-from-title {
          display: flex;
          align-items: center;
          height: 96px;
          padding-left: 29px;
          position: relative;

          &:after {
            position: absolute;
            content: "";
            width: 70px;
            height: 15px;
            background: #2ca7b3;
            z-index: 0;
            bottom: 20px;
            left: 27px;
          }

          &:before {
            position: absolute;
            content: "登录";
            width: 70px;
            height: 15px;
            top: 30px;
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #222222;
            z-index: 1;
          }
        }

        .login-from-box {
          width: 90%;
          height: 90px;
          margin: 0 auto;
          border-bottom: 1px solid #e5e5e5;

          input {
            width: 100%;
            height: 100%;
            border: none;
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
          }
        }

        .login-from-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 450px;
          height: 80px;
          margin: 20px auto 0;
          background: #2aa9b5;
          border-radius: 40px;
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #ffffff;
          cursor: pointer;
        }

        .login-from-bottom-handlle {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: 0 37px;

          .bottom-handle-btn {
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #2aa9b5;
            margin-top: 18px;
            cursor: pointer;
          }
        }

        .privacy {
          display: flex;
          align-items: center;
          width: 90%;
          margin: 10px auto 0;
          > p {
            border: 1px solid #999999;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            font-size: 26px;
            margin-right: 5px;
            cursor: pointer;
            background-color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            i {
              font-size: 12px;
            }
          }
          > p.checked {
            border-color: #2aa9b5;
            background-color: #2aa9b5;
            color: #ffffff;
          }
          > div {
            font-size: 22px;
            span {
              font-size: 22px;
              color: blue;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .cut-identity-content {
    width: 710px;
    height: 460px;
    background: #ffffff;
    border-radius: 10px;
    position: relative;

    .close-popup-cut {
      position: absolute;
      width: 24px;
      height: 24px;
      top: 30px;
      right: 30px;
      cursor: pointer;
    }

    .cut-title {
      text-align: center;
      font-size: 28px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #444444;
      margin: 59px auto 82px;
    }

    .cut-list {
      display: flex;
      align-items: center;
      justify-content: space-around;

      .cut-box {
        width: 210px;
        height: 221px;
        background: #ffffff;
        border: 3px solid #c9c9c9;
        border-radius: 30px;
        cursor: pointer;

        &:active {
          width: 210px;
          height: 221px;
          background: #ffffff;
          border: 3px solid #2ca7b3;
          border-radius: 30px;

          .cut-name {
            color: #2aa9b5;
          }
        }

        .cut-name {
          text-align: center;
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #888888;
          margin-top: 30px;
        }

        .cut-icon {
          display: block;
          width: 111px;
          height: 84px;
          margin: 40px auto 0;
        }
      }

      .cut-box-active {
        width: 210px;
        height: 221px;
        background: #ffffff;
        border: 3px solid #2ca7b3;
        border-radius: 30px;

        .cut-name {
          color: #2aa9b5;
        }
      }
    }
  }
}

.video-photo-shell {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 99;

  .applet-img {
    width: 300px;
    height: 300px;
    margin: 20px auto;
  }

  .camera_outer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 610px;
    padding: 20px 0;
    background-color: #fff;
    border: 1px solid #ccc;
    position: relative;

    .title {
      width: 100%;
      font-weight: 600;
      height: 60px;
      border-bottom: 1px solid #eee;
      font-size: 20px;
      padding: 0 30px;
      text-align: center;
    }
  }
}
</style>
